// src/pages/gowrianandham/gowrianandhamMap.jsx
import React from "react";
import "./gowrianandhamMap.css";

/**
 * Map section shown on the Gowri Anandham (Kanchipuram) page, between the
 * "Plot Advantages" cards and the "About Our Sites" video slider.
 * Uses the same Anandham Plots - Konnerikuppam embed already used for
 * Kanchipuram in the nav "Projects" dropdown (see navHeader.jsx).
 */
const GowriAnandhamMap = () => {
  return (
    <div className="ga-map-container">
      <h2 className="ga-features-heading green-text heading-bold">
        Find Us on the Map
      </h2>
      <div className="ga-map-frame-wrap">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.898926634652!2d79.7128381!3d12.849804299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52c34e52bc36cd%3A0xaeffaa46abf00ba0!2sGowri%20Anandham%20-%20anandham%20plots!5e0!3m2!1sen!2sin!4v1787037672385!5m2!1sen!2sin"
          width="100%"
          height="420"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Gowri Anandham Location Map"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default GowriAnandhamMap;
